import React from 'react';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import { Box, Link, Tooltip } from '@mui/material';

import { TASK_TRAVER_FOLDER } from 'components/root/Container/Layout/Tasks/Task/taskConstants';

import Divider from '../../../../../../../../common/elements/Divider/Divider';

import './TaskTravelStudyFolder.scss';

export function TaskTravelStudyFolder({ travelStudyFolder }) {
  const folderLink = travelStudyFolder?.link;

  if (!travelStudyFolder) return null;

  return (
    <>
      <Box className="task-travel-study-folder-group">
        <FolderOpenOutlinedIcon fontSize="medium" />
        {folderLink ? (
          <Tooltip title={folderLink} placement="top">
            <Link className="task-travel-study-folder-link" href={folderLink} underline="hover">
              {travelStudyFolder?.displayName || TASK_TRAVER_FOLDER}
            </Link>
          </Tooltip>
        ) : (
          <Box component="span">{TASK_TRAVER_FOLDER}</Box>
        )}
      </Box>
      <Divider />
    </>
  );
}
